function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Desktop",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Modal-Complete",
  transform: "translate(-293.000000, -119.000000)",
  fill: "#33CCFF"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon/Tick-Fill",
  transform: "translate(293.000000, 119.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M49,0 C76.0619527,0 98,21.9380473 98,49 C98,76.0619527 76.0619527,98 49,98 C21.9380473,98 0,76.0619527 0,49 C0,21.9380473 21.9380473,0 49,0 Z M69.6906965,29.2930947 L40.5956732,57.9111504 L28.5940876,45.9095649 C28.2069126,45.5223899 27.5813765,45.5201914 27.1868205,45.9147473 L21.7593935,51.3421743 C21.3693564,51.7322115 21.3760606,52.371291 21.7602421,52.7554725 L39.8885999,70.8838302 C40.2791057,71.274336 40.9124471,71.2783533 41.3111851,70.8849318 L76.5223571,36.1432421 C76.9175234,35.7533447 76.9262002,35.1256015 76.5316442,34.7310456 L71.1042172,29.3036186 C70.7141801,28.9135814 70.0834632,28.9067668 69.6906965,29.2930947 Z",
  id: "Combined-Shape"
}))));

function SvgIconTickFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "98px",
    height: "98px",
    viewBox: "0 0 98 98",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Tick Fill") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTickFill);
export default __webpack_public_path__ + "static/media/icon-tick-fill.5c8e31bb.svg";
export { ForwardRef as ReactComponent };